import { vnTemplate } from "./vnTemplate";
export class presetFilter_template extends vnTemplate {
    getTemplateHtml() {
        return `
            <div class="filter-preset  w-left">
                    <div class="dropdown">
                        <button class="dropdown-toggle filter">filter views</button>

                        <div class="dropdown-list">
                            <div class="filter-field-name">
                                <input class="input-text" placeholder="Add Filter View" data-bind="value: searchPresetName, valueUpdate: 'afterkeydown', event: {keyup: onPresetNameChange}"/>
                                <button class="clear icon i-close is-showing" type="button" data-bind="visible: searchPresetName() != '', event:{ click: onClearSearchPresetName }"><span class="hidden-text">clear</span></button>
                                <button class="btn highlight icon i-check" type="button" data-bind="visible: savePresetButtonEnabled(), event: { click: onSaveSearchPreset}" ><span>Save Preset</span></button>
                            </div>
                            <div data-bind="foreach: searchPresets">
                            <!-- ko if: $parent.searchPresetName() == '' || name.toLowerCase().indexOf($parent.searchPresetName().toLowerCase()) != -1 -->
                                <div class="btn secondary" >
                                    <!-- ko if: isOwner -->
                                    <input type="checkbox" data-bind="checked: $parent.searchPresetFavorite().id == id,  value: id,  attr: { id: 'searchPreset_' + id, name: 'searchPreset'}">
                                    <label class="form-label icon"  data-bind="attr: {for: 'searchPreset_' + id }, event:{ click: $parent.onToggleSearchPresetAsFavorite}" ></label>
                                    <!-- /ko -->

                                    <span data-bind="event:{ click: $parent.onApplySearchPreset}, attr: {for: 'searchPreset_' + id }, text: name"></span>

                                    <button class="copy icon i-copy" title="Copy Link to clipboard" data-bind="event:{ click: $parent.onClickBookmarkPreset}"><span class="hide-text">Copy to clipboard</span></button>
                                    <!-- ko if: isOwner -->
                                    <button class="delete icon i-delete" data-bind="event:{ click: $parent.onDeleteSearchPreset}"><span>delete</span></button>
                                    <!-- /ko -->
                                </div>
                            <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>
            `;
    }
    getTemplateName() {
        return "presetFilter-template";
    }
    getMainElementClasses() {
        return [this.filterContainerClass];
    }
    buildViewModel() {
        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            searchPresetSelected: ko.observable({ id: null, name: null }),
            searchPresetFavorite: ko.observable({ id: null, name: null }),
            searchPresetName: ko.observable(''),
            searchPresetType: ko.observable(''),
            searchPresets: ko.observableArray([]),
            showSaveSearchPreset: ko.observable(false),
            disableSaveSearchPreset: ko.observable(false),
            savePresetButtonEnabled: ko.observable(false),
            onSaveSearchPreset: (data, event) => {
                huit_neuf_this.onSaveSearchPreset();
            },
            onClearSearchPresetName: (data, event) => {
                huit_neuf_this.onClearSearchPresetName();
            },
            onToggleSearchPresetAsFavorite: (data, event) => {
                huit_neuf_this.onToggleSearchPresetAsFavorite(data);
            },
            onDeleteSearchPreset: (data, event) => {
                huit_neuf_this.onDeleteSearchPreset(data);
            },
            onApplySearchPreset: (data, event) => {
                huit_neuf_this.onApplySearchPreset(data);
            },
            onShowSaveSearchPreset: (data, event) => {
                huit_neuf_this.onShowSaveSearchPreset();
            },
            onClickBookmarkPreset: (data, event) => {
                huit_neuf_this.onClickBookmarkPreset(data, event);
            },
            onPresetNameChange: (data, event) => {
                huit_neuf_this.onPresetNameChange(data, event);
            },
        };
    }
    getViewModelForPresetRequest() {
        return {
            name: this.getTemplateViewModel().searchPresetName(),
            type: this.getTemplateViewModel().searchPresetType(),
            queryString: this.getQueryString(),
        };
    }
    setType(type) {
        this.getTemplateViewModel().searchPresetType(type);
    }
    getFilterTextFromId(filtersOptions, id) {
        let option = filtersOptions.filter((o) => (o.id == id)).shift();
        return option.name;
    }
    onSaveSearchPreset() {
        let isSaveDisabled = this.getTemplateViewModel().disableSaveSearchPreset();
        if (!isSaveDisabled) {
            this.disableSaveSearchPreset();
            this.caller.saveSearchPreset();
        }
    }
    onClearSearchPresetName() {
        this.cleanSearchPresetName();
    }
    disableSaveSearchPreset() {
        this.getTemplateViewModel().disableSaveSearchPreset(true);
    }
    enableSaveSearchPreset() {
        this.getTemplateViewModel().disableSaveSearchPreset(false);
    }
    cleanSearchPresetName() {
        this.getTemplateViewModel().searchPresetName('');
        this.getTemplateViewModel().savePresetButtonEnabled(false);
    }
    onToggleSearchPresetAsFavorite(data) {
        if (this.getTemplateViewModel().searchPresetFavorite() && this.getTemplateViewModel().searchPresetFavorite().id == data.id) {
            this.getTemplateViewModel().searchPresetFavorite({ id: null, name: null });
        }
        else {
            this.getTemplateViewModel().searchPresetFavorite(data);
        }
        this.caller.saveFavoriteSearchPreset({ presetId: data.id, searchPresetType: this.getTemplateViewModel().searchPresetType() });
    }
    onDeleteSearchPreset(preset) {
        let presets = this.getTemplateViewModel().searchPresets();
        let remainingPresets = presets.filter((p) => (p.id != preset.id));
        this.getTemplateViewModel().searchPresets(remainingPresets);
        this.caller.deleteSearchPreset(preset.id);
    }
    onApplySearchPreset(preset) {
        this.caller.redirectToPreset(preset.queryString);
        this.caller.getListFormData();
    }
    onShowSaveSearchPreset() {
        this.showSaveSearchPresetButton();
    }
    onClickBookmarkPreset(data, event) {
        this.caller.onClickBookmarkPreset(data.url);
    }
    onPresetNameChange(data, event) {
        if (this.getTemplateViewModel().searchPresetName().length > 0) {
            this.getTemplateViewModel().savePresetButtonEnabled(false);
        }
        let match = false;
        for (let preset of this.getTemplateViewModel().searchPresets()) {
            if (this.getTemplateViewModel().searchPresetName() == preset.name) {
                match = true;
                break;
            }
        }
        this.getTemplateViewModel().savePresetButtonEnabled(!match);
    }
    showSaveSearchPresetButton() {
        this.getTemplateViewModel().showSaveSearchPreset(true);
    }
    hideSaveSearchPresetButton() {
        this.getTemplateViewModel().showSaveSearchPreset(false);
    }
    getQueryString() {
        let href = window.location.href;
        let url = new URL(href);
        return url.search;
    }
    setMultiSelectorPresetFilters(multiFilter, ids) {
        if (typeof ids === 'undefined') {
            return;
        }
        let items = [];
        ids.forEach((id) => {
            items.push({ id: id });
        });
        multiFilter.setSelectedItems(items);
        multiFilter.setTags(ids, multiFilter.getItems());
        if (multiFilter.getTemplateViewModel().displaySelectionOrder()) {
            multiFilter.setSelectedItemsOrderBySelection(items);
        }
    }
    setOrderSelectionMultiSelectorPresetFilters(multiFilter, ids) {
        if (typeof ids === 'undefined') {
            return;
        }
        let items = [];
        ids.forEach((id) => {
            items.push({ id: id });
        });
        multiFilter.setSelectedItems(items);
        multiFilter.setTags(ids, multiFilter.getItems());
        multiFilter.setSelectAllEnabled(false);
        multiFilter.setDisplaySelectionOrder(true);
        if (multiFilter.getTemplateViewModel().displaySelectionOrder()) {
            multiFilter.setSelectedItemsOrderBySelection(items);
        }
    }
    setAutocompletePresetFilter(autocompleteFilter, id, name) {
        if (id != null && name != null && name != 'undefined') {
            autocompleteFilter.getTemplateViewModel().idSelectedItem(id);
            autocompleteFilter.getTemplateViewModel().nameSelectedItem(name);
        }
        else {
            autocompleteFilter.getTemplateViewModel().idSelectedItem(null);
            autocompleteFilter.getTemplateViewModel().nameSelectedItem(null);
        }
    }
    setMultipleAutocompletePresetFilter(autocompleteFilter, ids, names) {
        if (ids != null && names != null && ids.length == names.length) {
            let items = [];
            for (let i = 0; i < ids.length; i++) {
                items.push({ id: ids[i], name: names[i] });
            }
            autocompleteFilter.getTemplateViewModel().selectedItems(items);
            autocompleteFilter.getTemplateViewModel().selectedItemIds(ids);
            autocompleteFilter.getTemplateViewModel().selectedItemNames(names);
            autocompleteFilter.getTemplateViewModel().setTags(ids, items);
        }
        else {
            autocompleteFilter.getTemplateViewModel().selectedItems(null);
            autocompleteFilter.getTemplateViewModel().selectedItemIds(null);
            autocompleteFilter.getTemplateViewModel().selectedItemNames(null);
        }
    }
    setSearchPresets(presets) {
        for (let preset of presets) {
            preset = this.precalculatePresetFields(preset);
        }
        this.getTemplateViewModel().searchPresets(presets);
        let isFavorite = presets.filter((p) => (p.isFavorite == true));
        let preset = isFavorite.shift();
        this.setSearchPresetFavorite(preset);
    }
    precalculatePresetFields(preset) {
        if (typeof preset !== 'undefined') {
            preset['url'] = location.protocol + '//' + location.host + location.pathname + preset.queryString;
            let isOwner = false;
            let vnApp = this.caller.getVnAppZone().app;
            if (vnApp.loggedUser.isLoggedIn) {
                isOwner = vnApp.loggedUser.user.id == preset.idUser;
            }
            preset['isOwner'] = isOwner;
        }
        return preset;
    }
    setSearchPresetFavorite(preset) {
        preset = this.precalculatePresetFields(preset);
        if (preset != undefined) {
            this.getTemplateViewModel().searchPresetFavorite(preset);
        }
    }
    addCreatedPresetToList(preset) {
        preset = this.precalculatePresetFields(preset);
        this.cleanSearchPresetName();
        this.hideSaveSearchPresetButton();
        let presets = this.getTemplateViewModel().searchPresets();
        // append and sort.
        presets.push(preset);
        presets.sort((a, b) => (a.name.localeCompare(b.name)));
        this.getTemplateViewModel().searchPresets(presets);
        this.enableSaveSearchPreset();
    }
    setDates(datesFilter, type, startDate, endDate, startDateRange, endDateRange) {
        // date filters.
        if (typeof type === 'undefined') {
            type = 'dates';
        }
        datesFilter.getTemplateViewModel().selectedFilter(type);
        if (type == 'dates') {
            if (typeof startDate !== 'undefined' || typeof endDate !== 'undefined') {
                let startDateObj;
                if (startDate) {
                    startDateObj = new Date(startDate.replace(/-/g, '\/'));
                }
                let endDateObj;
                if (endDate) {
                    endDateObj = new Date(endDate.replace(/-/g, '\/'));
                }
                datesFilter.setDateRange(startDateObj, endDateObj);
            }
        }
        if (type == 'range') {
            if (typeof startDateRange !== 'undefined' || typeof endDateRange !== 'undefined') {
                datesFilter.setRange(startDateRange, endDateRange);
            }
        }
    }
}
